import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { HomeService } from 'src/app/home/service/home.service';
import { CommunicationProxyService } from 'src/app/shared/services/communication-proxy.service';
import { CommunicationSubjectEnum } from 'src/app/shared/enum/communication-subject-enum';
import { chartPerformanceTeamOptions } from './chart-performance-team-options';
import { Ranges } from '../../home-manager.component';

export interface BarChartPerformanceTeam {
  data: ChartDataSets[];
  teams: string[];
}

@Component({
  selector: 'app-chart-performance-team',
  templateUrl: './chart-performance-team.component.html',
  styleUrls: ['./chart-performance-team.component.scss']
})
export class ChartPerformanceTeamComponent implements OnInit {
  @Output() emitOnResize = new EventEmitter<number>();
  @Input() width;
  public longest: any;
  public barChartLabels: Label[] = [];
  public height: number;
  public barChartOptions: ChartOptions = chartPerformanceTeamOptions();
  public barChartType: ChartType = 'horizontalBar';
  public barChartLegend = true;
  public barChartData: ChartDataSets[] = [];
  public chartColors: Array<any> = [
    { backgroundColor: '#A51134', label: 'Quente' },
    { backgroundColor: '#0A68BF', label: 'Fria' },
    { backgroundColor: '#BD862C', label: 'Morna' },
    { backgroundColor: '#BFBCBC', label: 'Não categorizada' }
  ];
  public loading = true;
  public ranges: Ranges = {
    field: 'last_update_date'
  };
  public configBar = {
    barPercentage: 1,
    categoryPercentage: 0.7
  };

  constructor(private service: HomeService, private communicationProxyService: CommunicationProxyService) {}

  ngOnInit(): void {
    this.communicationProxyService
      .subscribe(CommunicationSubjectEnum.onManagerFiltersUpdated, (res: any) => {
        const { begin, end } = res.message;
        this.ranges.from = begin;
        this.ranges.to = end;
        this.getCountPerformanceTeam();
      });
  }

  getCountPerformanceTeam(): void {
    this.loading = true;
    this.service.getCountPerformanceTeam(this.ranges).subscribe((res: BarChartPerformanceTeam) => {
      this.barChartLabels = res.teams;
      this.getBarChartInfos(res.data);
      this.widthProportional();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  getBarChartInfos(data: ChartDataSets[]): void {
    this.barChartData = data.map((item: ChartDataSets) => {
      return { ...item, ...this.configBar }
    });
    this.height = this.barChartLabels.length * 70;
    document.documentElement.style.setProperty('--dynamic-height', this.height + 'px' );
  }

  onResize(): void {
    this.widthProportional();
  }

  widthProportional(): void {
    const fontSize = 10;
    this.longest = this.barChartLabels.reduce((a, b) => { return a.length > b.length ? a : b; });
    const calc = 400 + (this.longest.length * fontSize);
    document.documentElement.style.setProperty('--dynamic-width', calc + 'px' );
  }
}
